export const WHERE_TO_FIND_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/onde-encontrar#webpage",
   "url": "https://everest.ind.br/pt/onde-encontrar",
   "name": "Onde Encontrar Everest | Revendedores e Lojas Autorizadas",
   "description": "Encontre o revendedor ou loja autorizada Everest mais próxima de você em todo o Brasil.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/onde-encontrar#breadcrumb"
   },
   "mainEntity": {
    "@type": "ItemList",
    "name": "Revendedores Everest no Brasil",
    "description": "Lista de lojas e revendedores autorizados Everest em diferentes regiões do Brasil."
   },
   "potentialAction": {
    "@type": "SearchAction",
    "name": "Buscar revendedores Everest",
    "target": "https://everest.ind.br/pt/onde-encontrar?search={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/onde-encontrar#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Onde Encontrar",
     "item": "https://everest.ind.br/pt/onde-encontrar"
    }
   ]
  }
 ]
}
